import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, Typography } from "@material-ui/core";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useTheme } from "../../constants/themeProvider";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector} from 'react-redux';
import DefaultCourseImage from "../../assets/images/course-image.jpg"
import { ColorsConstant } from "../../constants/colorConstant";
import { setCourseId, setCourseName, setCourseProgress } from "examsbook-react-sdk/actions/getCourses";
import { reactGaEvent } from "examsbook-react-sdk/actions";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const CourseSideInfo = (props) => {
  const { courseCount, selectedCategory, settingsData } = props;
  const t = useTranslations();
  const theme = useTheme();
  const classes = useStyles();
  const location = useLocation();
  const [showComponent, setShowComponent] = useState(false);
  const [randomKey, setRandomKey] = useState(Math.random());
  const showEvaluationTest = useSelector(state => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
  const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const validItems = courseCount?.sort((a, b) => new Date(b?.startDate) - new Date(a?.startDate))?.filter(item => {
    const currentDate = Date.now();
    const endDate = item?.courseId?.endDate || item?.endDate;
    const differenceInDays = Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24));
    return ((selectedCategory === 'assigned' && item) ||
      (selectedCategory === 'expiring' && differenceInDays <= 7 && differenceInDays > 0) ||
      (selectedCategory === 'completed' && (item?.courseId?.progressPercent > 99 || currentDate > endDate)));
  });

  const handleCourseClick = (courseData, progressPercent) => {
    window.dispatchEvent(new Event('storage'));
    reactGaEvent("Course Material", "View Course");
    dispatch(setCourseName(courseData?.name));
    dispatch(setCourseId(courseData?._id));
    dispatch(setCourseProgress(progressPercent));
    history.push(`/course/${courseData?._id}`, {courseId:courseData?._id, subjectId: '', topicId:'', subjectDetail:courseData, testData: '', subjectName:'', topicName:'', courseName: courseData?.name, courseProgress: progressPercent, showEvaluationTest: showEvaluationTest, showInstructions: showInstructions});
  };

  useEffect(() => {
    if (selectedCategory && validItems?.length) {
      setRandomKey(Math.random());
    }
  }, [selectedCategory]);

  return (
    <Grid className={`${classes.parentDiv} commonShadow`} container key={randomKey}>
      <Box className={classes.parentHeading}>
        <Box>
          <Typography variant="subtitle1" className={classes.headingText}>
            {selectedCategory === 'assigned' ? t('Courses Assigned') : selectedCategory === 'expiring' ? t('Courses Expiring') : t('Courses Completed')}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.dataScroll}>
        {validItems && validItems.length ? validItems.map((item, index) => {
          const currentDate = Date.now();
          const endDate = item?.endDate;
          const differenceInDays = Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24));
          const isDisabled = false;
          const isExpired = differenceInDays < 0;
          if ((selectedCategory === 'assigned' && item) ||
            (selectedCategory === 'expiring' && differenceInDays <= 7 && differenceInDays > 0 && item?.progressPercent !== 100 ) ||
            (selectedCategory === 'completed' && (item?.progressPercent > 99 || currentDate > endDate))) {
            return (
              <Box key={index} className={`${classes.dataBlock + ' ' + classes.dataScrollVisible}`} style={isExpired ? { opacity: 0.6 } : {}}>
                <Box className={classes.leftHighlight}>
                  <Box component="img" 
                  src={ item?.featured || settingsData?.data?.[0]?.branding?.courseImage?.imagePath
                          ? item?.featured || settingsData?.data?.[0]?.branding?.courseImage?.imagePath
                         : DefaultCourseImage
                            }
                  className={classes.imageAlign} />
                </Box>
                <Box className='content-child-div' style={{ width: '100%' }}>
                  <Box
                    onClick={() => {
                      if (!isDisabled) {
                        handleCourseClick(item?.courseId, item?.progressPercent);
                      }
                    }}
                    className={isDisabled ? classes.disabledBox : classes.clickableBox}
                  >
                    <Typography variant="subtitle1" className={classes.textFix}>{item?.courseId?.name}</Typography>
                    <Typography variant="subtitle2" style={{ color: theme?.secondaryColor }} className={classes.percentageBlock}>{Math.round(item?.progressPercent ? item?.progressPercent : 0)}% {t('Completed')}</Typography>
                  </Box>
                </Box>
              </Box>
            )
          }
        }) : showComponent && <Box className={classes.noRecord}><Typography variant="subtitle2" className={classes.noData}>{t('No record found')}</Typography></Box>}
      </Box>
      <Typography className={`${classes.seeMore} ${ !validItems || validItems?.length <= 4 ? classes.disabled : '' }`} 
      onClick={
        validItems && validItems.length > 4
          ? () => history.push('/my-courses', { params: window.location.pathname})
          : undefined
      }>{t('See More')}</Typography>
    </Grid>
  )
}

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    border: '1px solid rgba(12, 52, 80, 0.20)',
    background: '#FFF',
    display: 'block',
    height: '100%',
    borderRadius: '6px',
    position: 'relative',
    '@media (max-width:959px)': {
      maringTop: "20px",
    },
  },
  parentHeading: {
    width: '100%',
    alignSelf: 'center',
    padding: '0px 16px',
    borderBottom: `1px solid ${ColorsConstant.cardBorders}`
  },
  headingText: {
    margin: '16px 0px',
    color: ColorsConstant.defaultBlue,
    fontSize: "18px",
    fontWeight: 500,
  },
  dataBlock: {
    display: 'flex',
    width: '100%',
    padding: '16px',
    gap: '16px'
  },
  disabled: {
    color: `${ColorsConstant.gray} !important`,
    opacity: '0.3',
    cursor: 'not-allowed !important'
  },
  leftHighlight: {
    minWidth: '50px',
    minHeight: '50px',
    background: '#0c345017',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  imageAlign: {
    width: '40px',
    height: '40px',
    objectFit: 'contain'
  },
  noRecord: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '280px'
  },
  percentageBlock: {
    display: 'block',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '80%',
  },
  noData: {
    display: 'block',
    margin: '16px',
    width: '100%',
    textAlign: 'center',
    color: '#00000080',
    fontSize: '1rem',
    fontWeight: '400'
  },
  dataScroll: {
    maxHeight: 340,
    overflow: 'auto'
  },
  dataScrollVisible: {
    animation: 'fadeIn 1s',
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '50%': { opacity: 0.5 },
    '100%': { opacity: 1 },
  },
  textFix: {
    fontSize: '14px',
    color: ColorsConstant.descriptionColor,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '80%',
    '@media (min-width:960px) and (max-width:1023px)': {
      maxWidth: '13vw',
    },
    '@media (min-width:1024px) and (max-width:1150px)': {
      maxWidth: '10ch !important'
    },
    '@media (min-width:1151px) and (max-width:1440px)': {
      maxWidth: '12vw',
    },
  },
  seeMore: {
    fontSize: '14px',
    fontWeight: 600,
    textAlign: 'center',
    marginTop: '14px',
    cursor: 'pointer',
    position: 'absolute',
    bottom: 15,
    left: 0,
    right: 0,
    color: ColorsConstant.defaultBlue,
    '@media (max-width: 767px)': {
      position: 'static'
    }
  },
  clickableBox: {
    cursor: 'pointer',
  },
  disabledBox: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
}));
export default CourseSideInfo;